import {useWishlist} from './useWishlist';

/**
 * Hook to check if a product is in the user's wishlist
 *
 * Uses cached wishlist data from useWishlist - returns synchronously
 * without waiting for a refetch.
 *
 * @param barcode - Product barcode (product_code)
 * @param productId - Optional MFL product ID for fallback matching
 * @returns boolean indicating if item is in wishlist
 *
 * @example
 * const isFavourite = useIsInWishlist(item.product_code, item.product_id);
 */
export const useIsInWishlist = (barcode?: string, productId?: string): boolean => {
  const {data: wishlistData} = useWishlist();

  if (!barcode && !productId) return false;
  if (!wishlistData?.entries) return false;

  return wishlistData.entries.some(
    entry => entry.product_code === barcode || entry.product_id === productId,
  );
};
